import React, { useEffect, useState } from 'react'
import FilterPage, {generateInitialValue} from '../fragments/filter-page'
import {
	action_add_search_list,
	action_fetch_search_list,
	action_fetch_search_sorters,
	action_fetch_search_filter,
	__Default_Search_Limit_For_DeskTop__
} from '../../../../../store/actions/pages/search'

import { filterItemsToString, getFilterItemsFromQuery, getUrl } from '../../../../pages/listing/utils'
import { useDispatch, useSelector } from 'react-redux'
import List from '../components/list'
import { useHistory } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import { FormattedMessage } from 'react-intl'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Empty from '../fragments/empty-page'
import { useSensors } from '../../../../hooks/sensor'
import { generateFilter } from '../../../../utils/sensor'
import FacebookEvents from '../../../../ads/events/facebook'
import BottomBannerTip from '../../../layout/fragments/bottom-banner'

const decodeCode = str => {
	let decoded = str
	try {
		decoded = decodeURIComponent(str)
	} catch (e) { }
	return decoded
}


const getValidFilterItems = items => {
	const newItems = []

	items?.forEach(item => {
		if (['color', 'size', 'tags', 'category', 'category_ids'].indexOf(item.fieldName) >= 0 || item.fieldName?.indexOf('tags-') === 0) {
			newItems.push(item)
		}
	})
	return newItems
}

const parseParams = search => {
	if (!search) return
	let newParams = {}
	Object.keys(search).forEach(key => {
		if (search[key] instanceof Array) {
			newParams[key] = search[key]?.filter((value, index, s) => s.indexOf(value) === index).join?.(',')
		} else {
			newParams[key] = search[key]
		}
	})

	if (search?.sort_by) {
		newParams['parentSkus'] = search.sort_by
	}
	return newParams
}


const Search = props => {
	useStyles(classes)
	const dispatch = useDispatch()
	const history = useHistory()
	const pageSearch = useSelector((state) => state.pageSearch)
	const sorters = pageSearch?.sorters
	const query = useQuery()
	const baseUrl = `/i/search/result?key=${query?.key || query?.searchValue}`
	const searchValue = decodeCode(query?.searchValue || query?.key)

	const [sensors, setSensors] = useState(useSensors())
	const filterStr = generateFilter(pageSearch?.filterData, pageSearch?.sorters)

	const [data, setData] = useState({
		searchValue,
		sorter: (sorters instanceof Array) ? sorters?.[query.sort || 0]?.value : query.sort,
		startPrice: Number(query?.lowerPrice) || undefined,
		endPrice: Number(query?.higherPrice) || undefined,
		filterItems: generateInitialValue(query, pageSearch?.filterVo?.filterItems)
	})

	const sort = sorters?.findIndex(s => s.value === data?.sorter) || 0


	useEffect(() =>{
		if (window.GeekoSensors) {
            window.GeekoSensors.Track('SearchResult', {
                resource_content: query?.searchValue || query?.key,
                product_count: pageSearch?.total
            })
        }
		FacebookEvents.search({search_string: query?.searchValue || query?.key})
	}, []);


	const filterHandle = (filterItems, sort, price) => {
		const filter = {
            searchValue,
			sorter: (sorters instanceof Array) ? sorters?.[sort || 0]?.value : sort,
			startPrice: price?.minPrice || undefined,
			endPrice: price?.maxPrice || undefined,
			filterItems
		}
		setData(filter)
		dispatch(action_fetch_search_list(filter, {searchValue, limit: __Default_Search_Limit_For_DeskTop__ }, {}))
		const url = getUrl(baseUrl, filterItemsToString(filterItems, sort, price))
		history.replace(url)
	}

	const onScroll = () => {
		dispatch(action_add_search_list(data, { ...query, parentSkus: query?.sort_by, searchValue, skip: pageSearch?.skip, limit: __Default_Search_Limit_For_DeskTop__ }, {}))
	}

	return <FilterPage
		links={[
			{
				href: '#',
				title: <span>
					<span>{decodeCode(query?.searchValue || query?.key)}</span>
					{
						pageSearch?.total > 0 && <span className={classes.Total}>
							(<FormattedMessage id="count_items" values={{ total: pageSearch?.total }} defaultMessage="{total} Items" />)
						</span>
					}
				</span>,
				keywords: [],
			}
		]}
		baseUrl={baseUrl}
		title={decodeCode(query?.searchValue || query?.key)}
		filterVO={pageSearch?.filterVo}
		sorters={pageSearch?.sorters}

		value={data?.filterItems}
        sort={sort}
        minPrice={data?.startPrice}
        maxPrice={data?.endPrice}


		onFilter={filterHandle}>
			{
				pageSearch?.finished && (!pageSearch?.list || pageSearch?.list?.length < 1) ? <Empty /> : <List filter={filterStr} sensors={sensors} products={pageSearch?.list} request={onScroll} loading={pageSearch?.loading} finished={pageSearch?.finished} />
			}

		<BottomBannerTip />
	</FilterPage>
}


Search.fetchData = async (store, params, search, headers) => {

	const initialFilterItems = getFilterItemsFromQuery(search)
	const sort = search.sort || 0
	const sorters = await store.dispatch(action_fetch_search_sorters({}, headers))
	const sorter = (sorters instanceof Array) ? sorters?.[sort]?.value : sort

    const searchValue = decodeCode(search?.searchValue || search?.key)

	const filter = {
		sorter: sorter,
		startPrice: Number(search?.lowerPrice) || undefined,
		endPrice: Number(search?.higherPrice) || undefined,
		filterItems: getValidFilterItems(initialFilterItems),
	}

	const parsedParams = parseParams(search) || {}

	parsedParams.limit = __Default_Search_Limit_For_DeskTop__

	const values = await Promise.all([
		store.dispatch(action_fetch_search_list(filter, parsedParams, headers)),
		store.dispatch(action_fetch_search_filter({ searchValue }, headers)),
	])
	return [...values, sorters]
}

export default Search